import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const Navbar = () => {
  const { user, setUser, isAdmin, isRecruiter, isHR } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);
  const [navOpen, setNavOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('auth_token');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  const userName = user?.name || user?.username || user?.email || 'User';
  const isPublicPage = location.pathname === '/' || location.pathname === '/resume-portal';

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  useEffect(() => {
    if (!navOpen) {
      setUserMenuOpen(false);
    }
  }, [navOpen]);

  if (!user) {
    return (
      <header className="navbar-header navbar-header-simple">
        <button
          type="button"
          className="navbar-logo-button"
          onClick={() => navigate('/')}
        >
          <img src="https://www.intmavens.com/wp-content/uploads/2022/09/logo-300x180.png" alt="IntMavens Logo" className="navbar-logo" />
          <div className="navbar-title-block">
            <span className="navbar-title">IntMavens</span>
            <span className="navbar-subtitle">RECRUITER PORTAL</span>
          </div>
        </button>
        <div className="navbar-logo-placeholder" aria-hidden="true" />
      </header>
    );
  }

  return (
    <header className="navbar-header" ref={navRef}>
      <div className="navbar-logo-container">
        <img src="https://www.intmavens.com/wp-content/uploads/2022/09/logo-300x180.png" alt="IntMavens Logo" className="navbar-logo" />
        <div className="navbar-title-block">
          <span className="navbar-title">IntMavens</span>
          <span className="navbar-subtitle">RECRUITER PORTAL</span>
        </div>
      </div>
      <button
        className="navbar-toggle"
        type="button"
        aria-label="Toggle navigation"
        aria-expanded={navOpen}
        onClick={() => setNavOpen((open) => !open)}
      >
        {navOpen ? '-' : '+'}
      </button>
      <nav>
        <ul className={`navbar-links${navOpen ? ' open' : ''}`}>
          <li>
            <button
              type="button"
              className="navbar-link"
              onClick={() => {
                setNavOpen(false);
                navigate('/resume');
              }}
            >
              Resume
            </button>
          </li>
          {/* <li>
            <button
              type="button"
              className="navbar-link"
              onClick={() => {
                setNavOpen(false);
                navigate('/resume-update');
              }}
            >
              Resume Update
            </button>
          </li> */}
          {isAdmin() && (
            <li>
              <button
                type="button"
                className="navbar-link"
                onClick={() => {
                  setNavOpen(false);
                  navigate('/scrapper');
                }}
              >
                Scrapper
              </button>
            </li>
          )}
          {(isRecruiter() || isHR() || isAdmin()) && (
            <li>
              <button
                type="button"
                className="navbar-link"
                onClick={() => {
                  setNavOpen(false);
                  navigate('/candidates', {
                    state: {
                      clearFilters: true
                    }
                  });
                }}
              >
                Candidates
              </button>
            </li>
          )}
          <li>
            <button
              type="button"
              className="navbar-link"
              onClick={() => {
                setNavOpen(false);
                navigate('/jobs');
              }}
            >
              Jobs
            </button>
          </li>
          {(isRecruiter() || isHR()) && (
            <li>
              <button
                type="button"
                className="navbar-link"
                onClick={() => {
                  setNavOpen(false);
                  navigate('/candidates', {
                    state: {
                      initialFilters: {
                        feedbackStatus: [
                          'Ready to Pitch',
                          'Applied for Job',
                          'Interview Scheduled',
                          'Interview Round 1',
                          'Interview Round 2',
                          'Interview Round 3',
                          'Interview Round 4',
                          'Interview Rejected',
                          'HR Interview',
                          'Offered',
                          'Offer Rejected',
                          'Offer Accepted',
                          'Onboarding',
                          'Onboarded'
                        ]
                      }
                    }
                  });
                }}
              >
                Ready to Pitch
              </button>
            </li>
          )}
          <li className="navbar-dropdown navbar-dropdown-container">
            <div className="navbar-dropdown-inner">
              <button
                type="button"
                className="navbar-link navbar-dropdown-btn"
                onClick={() => setUserMenuOpen((open) => !open)}
              >
                welcome: {userName}
              </button>
              <ul className={`navbar-dropdown-menu${userMenuOpen ? ' show' : ''}`}>
                <li>
                  <button
                    type="button"
                    className="navbar-link"
                    onClick={() => {
                      setNavOpen(false);
                      setUserMenuOpen(false);
                      navigate('/userdetails');
                    }}
                  >
                    User Details
                  </button>
                </li>
                {(isHR() || isAdmin()) && (
                  <>
                    <li>
                      <button
                        type="button"
                        className="navbar-link"
                        onClick={() => {
                          setNavOpen(false);
                          setUserMenuOpen(false);
                          navigate('/adduser');
                        }}
                      >
                        Add User
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        className="navbar-link"
                        onClick={() => {
                          setNavOpen(false);
                          setUserMenuOpen(false);
                          navigate('/password');
                        }}
                      >
                        Change Password
                      </button>
                    </li>
                  </>
                )}
              </ul>
            </div>
            <button
              className="logout-btn navbar-logout-button"
              type="button"
              onClick={handleLogout}
            >
              Logout
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;